// @flow
import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";


const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class SlowMotionSettings extends React.Component {
  constructor(props) {
    super(props);
    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    // #endregion
  }
  // #region events
  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.files[0]});
  }

  // #endregion
  render() {
    const { files } = this.props;

    const slowMotionSoundEffectPlayback =  
    files.slowMotionSoundEffectFile !== undefined ? (
      <React.Fragment>
        <audio controls>
          <source src={files.slowMotionSoundEffectFile} type="video/mp4" />
          Your browser does not support the audio tag.
        </audio>
      </React.Fragment>
    ) : null;
    return (
      <React.Fragment>
        <Section title="Slow motion settings" subsection>
          <FormGroup row>
          <Label for="slowMotionSoundEffect" sm={2}>
              Sound effect
            </Label>
            <Col>
          <Input
              type="file"
              name="slowMotionSoundEffect"
              id="slowMotionSoundEffect"
              onChange={this.handleChange}
              accept="audio/mpeg"
              required
          />
          </Col>
           <Col>{slowMotionSoundEffectPlayback}</Col>
          </FormGroup>
        </Section>
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SlowMotionSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/SlowMotionSettings.jsx